import { SECTION_PAGE } from "./useSectionPagination";
import { useStickyState } from "./useStickyState";

/**
 * A grid's rows-per-page choice, remembered under its table id. Feed the pair
 * to {@link useSectionPagination}'s `pageSize` / `onPageSizeChange` to make an
 * accordion grid's page size grid-wide and persistent.
 *
 * `options` are the sizes the grid's footer offers: a stored value outside
 * them (stale or hand-edited) reads as the default rather than requesting an
 * odd page.
 */
export function useStickyPageSize(
  tableId: string,
  options: readonly number[],
  defaultSize = SECTION_PAGE,
): readonly [number, (size: number) => void] {
  const [stored, setStored] = useStickyState<number>(
    defaultSize,
    `table-page-size-${tableId}`,
  );
  return [options.includes(stored) ? stored : defaultSize, setStored];
}
